import { Loading } from 'element-ui';

import router from '/src/router';
import store from '/src/store';

let isFirstLoad = true;

function routerTo(guid, to, next) {
    if (to.meta.login && !guid) {
        // 必须登录
        next({ name: 'error404' });
    } else {
        next();
    }
}

router.beforeEach((to, from, next) => {
    const { token, userInfo } = store.getters;

    // console.log(to.name, token);
    // 首次加载
    if (isFirstLoad) {
        isFirstLoad = false;

        if (to.query) {
            store.dispatch('SetAccessQuery', JSON.stringify(to.query));
        }
    }

    if (to.matched && !to.matched.length) {
        // 嵌套路径片段的路由记录不存在，表示路由中没有配置此页面
        next({ name: 'error404' });
    } else {
        if (token && !userInfo.guid) {
            // token存在，用户信息不存在，则请求用户信息
            const loadingObj = Loading.service({
                lock: true,
                text: '加载中...',
                // spinner: 'el-icon-loading'
            });

            store
                .dispatch('GetUserInfo')
                .then(data => {
                    loadingObj.close();

                    routerTo(data.guid, to, next);
                })
                .catch(() => {
                    loadingObj.close();
                });
        } else {
            routerTo(userInfo.guid, to, next);
        }
    }
});

// router.afterEach(() => {
//     // 进度条结束
// });
